const th = {
  title: 'เครื่องมืออัตโนมัติ',
  api: 'เชื่อมต่อระบบ',
  ai: 'เอไอ และฐานความรู้',
  broadcasts: 'บรอดแคสต์',
  contacts: 'ความยินยอมผู้รับ',
  audit: 'ประวัติการทำงาน',
  refresh: 'โหลดใหม่',
  save: 'บันทึก',
  create: 'สร้างใหม่',
  name: 'ชื่อ',
  enabled: 'เปิดใช้งาน',
  method: 'วิธี HTTP',
  url: 'URL ปลายทาง HTTPS',
  headers: 'รหัสเข้าระบบและส่วนหัวคำขอ (JSON)',
  headersHelp:
    'เก็บเข้ารหัส ใช้ Authorization หรือ X-* เท่านั้น เว้นว่างเมื่อแก้ไขเพื่อเก็บรหัสเดิม ใส่ ออบเจ็กต์ว่างเพื่อล้าง',
  apiHelp:
    'กำหนดปลายทางที่เชื่อถือได้ก่อนนำไปเลือกใน เวิร์กโฟลว์ รองรับ JSON และการจับคู่ค่าตอบกลับ ไม่ตามลิงก์เปลี่ยนเส้นทาง และไม่เรียกเครือข่ายภายใน',
  credentialsSaved: 'มีรหัสที่บันทึกแล้ว',
  noCredentials: 'ไม่มีรหัส',
  edit: 'แก้ไข',
  cancel: 'ยกเลิก',
  instructions: 'แนวทางการเขียนของ เอไอ',
  localModel: 'โมเดลในเครื่อง',
  aiHelp:
    'เอไอ ร่างคำตอบ สรุปแชท และปรับถ้อยคำได้ในหน้าแชท ใช้ข้อมูลที่ยืนยันในบัญชีนี้ เจ้าหน้าที่ตรวจและกดส่งเอง',
  knowledge: 'บทความฐานความรู้',
  articleTitle: 'ชื่อบทความ',
  articleBody: 'ข้อมูลที่ใช้ตอบ',
  approved: 'ยืนยันข้อมูลแล้ว อนุญาตให้ เอไอ ใช้อ้างอิง',
  draft: 'ฉบับร่าง',
  delete: 'ลบ',
  deleteConfirm: 'ลบบทความนี้จากฐานความรู้หรือไม่?',
  saved: 'บันทึกแล้ว',
  inbox: 'ช่องทาง',
  choose: 'เลือก',
  audienceLabel: 'ป้ายกลุ่มผู้รับ (ป้ายบนข้อมูลผู้ติดต่อ)',
  allConsented: 'ทุกคนที่ยืนยันความยินยอม',
  scheduleLabel: 'ป้ายกลุ่มแชทที่จะเริ่มตามเวลา (ป้ายบนแชท)',
  content: 'ข้อความ',
  rate: 'จำนวนคนต่อนาที',
  timezone: 'เขตเวลา IANA',
  preview: 'ตรวจข้อความและรายชื่อผู้รับ',
  report: 'ผลการส่ง',
  broadcastHelp:
    'รองรับ LINE และกล่อง LAB ส่งถึงรายชื่อที่ยินยอมเท่านั้น ไม่ส่งไปยังผู้ติดตามทั้งหมดของ OA การส่ง LINE ใช้โควตาของบัญชี',
  stopHelp:
    'ข้อความแนบวิธียกเลิกข่าวสาร ลูกค้าพิมพ์ STOP / ยกเลิกข่าวสาร แล้วจะถูกตัดออกจากรายการที่ยังไม่ส่ง',
  eligible: 'ส่งได้',
  excluded: 'ไม่ส่ง',
  status: 'สถานะ',
  reason: 'เหตุผล',
  quota: 'โควตา LINE',
  previewHelp:
    'รายชื่อจะถูกตรึงตอนยืนยัน และตรวจการยกเลิกความยินยอมอีกครั้งก่อนส่ง ตัวอย่างใช้ได้ 10 นาที',
  scheduleAt: 'วันเวลาส่งตามนาฬิกาเครื่องนี้ (ว่าง = เริ่มรอบถัดไป)',
  confirmSend: 'ตรวจเนื้อหา ผู้รับ ความยินยอม และโควตาแล้ว',
  scheduleSend: 'ยืนยันส่ง / ตั้งเวลา',
  scheduleConfirm:
    'ยืนยันบรอดแคสต์รายการนี้? ระบบจะส่งข้อความจริงตามรายชื่อและเวลาที่ตรวจไว้',
  pause: 'พักการส่ง',
  resume: 'ส่งต่อรายการที่เหลือ',
  cancelCampaign: 'ยกเลิกรายการที่เหลือ',
  cancellationHelp:
    'พัก/ยกเลิกหยุดเฉพาะรายการที่ยังไม่เข้าคิวส่ง ข้อความที่ส่งหรือเข้าคิวแล้วเรียกคืนไม่ได้',
  export: 'ดาวน์โหลดผล CSV',
  noItems: 'ยังไม่มีรายการ',
  next: 'ถัดไป',
  previous: 'ก่อนหน้า',
  search: 'ค้นหาชื่อลูกค้า',
  opted_in: 'ยืนยันรับข่าวสาร',
  opted_out: 'ยกเลิกแล้ว',
  unknown: 'ยังไม่มีหลักฐาน',
  evidence: 'หลักฐาน/ที่มาความยินยอม',
  evidenceHelp:
    'บันทึกวัน เวลา และช่องทางที่ลูกค้ายืนยัน ห้ามถือว่าทุกคนที่ทักแชทยินยอมรับการตลาด',
  pending: 'รอประมวลผล',
  working: 'กำลังสร้างคำตอบ',
  completed: 'เสร็จแล้ว',
  failed: 'ไม่สำเร็จ',
  scheduled: 'ตั้งเวลาแล้ว',
  sending: 'กำลังส่ง',
  dispatched: 'นำเข้าคิวครบแล้ว',
  paused: 'พักไว้',
  cancelled: 'ยกเลิกแล้ว',
  queued: 'เข้าคิวส่ง',
  sent: 'ส่งออกจากระบบ',
  delivered: 'ผู้ให้บริการรับคำขอแล้ว',
  read: 'อ่านแล้ว',
  skipped: 'ข้าม',
  blocked: 'ถูกบล็อก',
  missing_destination: 'ไม่มีที่อยู่ปลายทาง',
  no_consent: 'ยังไม่ยืนยันหรือยกเลิกความยินยอม',
  assistant: 'เอไอ ช่วยตอบ',
  answer: 'ร่างจากฐานความรู้',
  summary: 'สรุปเพื่อส่งต่อ',
  rewrite: 'ปรับถ้อยคำ',
  input: 'คำถาม / ร่างข้อความ (ร่างคำตอบว่างได้เพื่อใช้ข้อความล่าสุด)',
  generate: 'ให้ เอไอ ช่วย',
  review: 'ตรวจข้อเท็จจริงและความเหมาะสมก่อนส่ง เอไอ อาจผิดพลาดได้',
  insert: 'ใส่ในช่องร่างข้อความ',
  copy: 'คัดลอก',
  copied: 'คัดลอกแล้ว',
  sources: 'ข้อมูลอ้างอิง',
  aiDisabled: 'ผู้ดูแลยังไม่ได้เปิด เอไอ',
  waitAi: 'กำลังทำงานในเครื่อง อาจใช้เวลาหลายนาที',
  noGrounding: 'ข้อมูลยืนยันไม่พอ ให้เจ้าหน้าที่ตรวจสอบ',
  mode: 'วิธีตรวจ',
  all: 'ต้องครบทุกข้อ',
  any: 'ตรงอย่างน้อยหนึ่งข้อ',
  addRule: 'เพิ่มเงื่อนไข',
  addGroup: 'เพิ่มกลุ่มเงื่อนไข',
  remove: 'เอาออก',
  source: 'ข้อมูลที่ตรวจ',
  key: 'ชื่อฟิลด์ / ตัวแปร / ป้าย',
  operator: 'การเปรียบเทียบ',
  value: 'ค่า',
  variable: 'ตัวแปร เวิร์กโฟลว์',
  contact_field: 'ฟิลด์ผู้ติดต่อ',
  conversation_field: 'ฟิลด์แชท',
  label: 'ป้ายบนแชท',
  priority: 'ความสำคัญ',
  inbox_id: 'รหัสกล่อง',
  equals: 'เท่ากับ',
  not_equals: 'ไม่เท่ากับ',
  contains: 'มีข้อความ',
  not_contains: 'ไม่มีข้อความ',
  greater: 'มากกว่า',
  less: 'น้อยกว่า',
  at_least: 'มากกว่าหรือเท่ากับ',
  at_most: 'น้อยกว่าหรือเท่ากับ',
  exists: 'มีค่า / มีป้าย',
  missing: 'ไม่มีค่า / ไม่มีป้าย',
  days: 'วัน (0 อาทิตย์, 1 จันทร์ … 6 เสาร์)',
  start: 'เริ่ม',
  finish: 'สิ้นสุด',
  hoursHelp: 'เริ่มเท่ากับสิ้นสุด = เปิดทั้งวัน รองรับช่วงข้ามเที่ยงคืน',
  at: 'วันเวลา ISO พร้อมเขตเวลา',
  frequency: 'ความถี่',
  once: 'ครั้งเดียว',
  daily: 'ทุกวัน',
  weekly: 'รายสัปดาห์',
  time: 'เวลาตามเขตเวลาที่เลือก',
  scheduleHelp:
    'เริ่มเฉพาะแชทเปิดที่มีป้ายบนแชทนี้ สูงสุด 500 แชท งานค้างเกิน 24 ชั่วโมงจะข้าม ไม่รันสะสมย้อนหลัง',
  connection: 'การเชื่อมต่อที่บันทึกไว้',
  query: 'พารามิเตอร์คำขอ (JSON)',
  body: 'เนื้อหาคำขอ (JSON)',
  mapping:
    'จับคู่ตัวแปรกับ เส้นทางข้อมูล JSON เช่น order_status → $.status (JSON)',
  statusVariable: 'ตัวแปรเก็บ สถานะ HTTP',
  jsonHelp:
    'ใส่ ออบเจ็กต์ JSON ที่ถูกต้อง ค่าข้อความใช้ตัวแปรแบบปีกกาคู่ได้ รหัสลับเก็บในหน้าเชื่อมต่อ API',
  invalidJson: 'JSON ต้องเป็น object ที่ถูกต้อง',
  prompt: 'คำถาม / ข้อความให้ เอไอ ตรวจ',
  outputVariable: 'ตัวแปรเก็บผล',
  classify: 'จัดหมวดข้อความ',
  choices: 'หมวดที่อนุญาต คั่นด้วยจุลภาค',
  aiStepHelp:
    'หากข้อมูลไม่พอหรือ เอไอ ล้มเหลวจะออกทางไม่สำเร็จ ควรเชื่อมไปยังเจ้าหน้าที่',
  accountChanged: 'เปลี่ยนบัญชีแล้ว กรุณาโหลดใหม่',
  unsaved: 'มีข้อมูลที่ยังไม่บันทึก ออกจากหน้านี้หรือไม่?',
  labNote: 'ช่อง LAB: ไม่มีการส่งออกภายนอก',
  submitted: 'บันทึกการตั้งเวลาแล้ว',
  action: 'การทำงาน',
};
export const automationMessages = { th: { AUTO: th }, en: { AUTO: { ...th } } };
export const inputClass =
  'w-full rounded-lg border border-n-weak bg-n-background px-3 py-2 text-sm text-n-slate-12';
export const buttonClass =
  'rounded-lg border border-n-weak px-3 py-2 text-sm hover:bg-n-alpha-2 disabled:opacity-40';
export const primaryClass =
  'rounded-lg bg-n-brand px-3 py-2 text-sm text-white disabled:opacity-40';
export const newRule = () => ({
  source: 'variable',
  key: 'answer',
  operator: 'equals',
  value: '',
});
